<template>
  <div> 
    <v-card-title> 
    <v-text-field
      v-model="search"
      append-icon="search"
      label="検索"
      single-line
      hide-details
    ></v-text-field>
  <!--v-spacer></v-spacer-->
  <v-flex xs12 sm3></v-flex>
  <v-flex xs12 sm3 text-xs-center>
      <v-btn fab dark small color="primary" @click="addItem()"><v-icon dark>add</v-icon></v-btn>
  </v-flex>
  </v-card-title>

  <v-data-table
    :headers="headers"
    :search="search"
    :loading="loading"
    :items="catalogs"
    :dark="false"
    hide-actions
    :pagination.sync="pagination"
    class="elevation-1"
  >
    <template v-slot:items="props">
      <td class="text-xs-left">{{ props.item.serial1 }}</td>
      <td class="text-xs-left">{{ props.item.serial2 }}</td>
      <td class="text-xs-left">{{ props.item.memo }}</td>
      <td class="text-xs-left">{{ props.item.createdt }}</td>
      <td class="justify-center layout px-0">
        <v-btn color="pink" fab small dark @click="editItem(props.item)"><v-icon>edit</v-icon></v-btn>
      </td>
    </template>
 
    <template>
      <v-alert v-if="isThereData" :value="true" color="primary" icon="warning">
        Now loading.
      </v-alert>
      <v-alert v-else :value="true" color="error" icon="warning" >
        Nothing to display.
      </v-alert>
    </template>
  </v-data-table>
  <div class="text-xs-center pt-2">
    <v-pagination v-model="pagination.page" :length="pages" :total-visible="5"></v-pagination>
  </div>
  
  <transition>
   <v-toolbar flat color="white" height="20px">
      <v-dialog v-model="dialog" persistent max-width="680px" min-width="600px">
        <template v-slot:activator="{ on }">
            <!--v-btn fab dark small color="primary" @click="addItem()"><v-icon dark>add</v-icon></v-btn-->
        </template>
        <v-card>
          <v-toolbar dark color="primary" height="40">
          <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs12>
                    <v-layout row wrap>
                    <v-flex xs5 sm6> 
                        <v-card flat tile class="d-flex justify-center">
                        <v-img :src="svgPlan" min-width="260px" max-width="260px"></v-img>
                        </v-card>
                        <v-card flat tile class="d-flex justify-center">
                          <v-img :src="editedItem.url1" min-width="260px" max-width="260px" min-height="260px" max-height="260px" aspect-ratio="1">
                              <v-layout fill-height align-center justify-center ma-0>
                                  <v-progress-circular v-if="uploading1" :size="80" :width="15" :rotate="360"
                                      :value="progressUpload" color="primary"></v-progress-circular>
                              </v-layout>       
                          </v-img>
                        </v-card>
                        <v-btn small color="primary" dark @click.native="selectFile(1)"><v-icon>add_a_photo</v-icon></v-btn>
                        <input id="files" type="file" name="file1" ref="uploadInput" accept="image/*" :multiple="false" @change="detectFiles($event)" style="width:10px">
                        <v-text-field v-model="editedItem.serial1" label="Serial1"></v-text-field>
                    </v-flex>
                    <v-flex xs5 sm6>
                        <v-card flat tile class="d-flex justify-center">
                        <v-img :src="svgRouph" min-width="260px" max-width="260px"></v-img>
                        </v-card> 
                        <v-card flat tile class="d-flex justify-center">
                          <v-img :src="editedItem.url2" min-width="260px" max-width="260px" min-height="260px" max-height="260px" aspect-ratio="1">
                              <v-layout fill-height align-center justify-center ma-0>
                                  <v-progress-circular v-if="uploading2" :size="80" :width="15" :rotate="360"
                                      :value="progressUpload" color="primary">%</v-progress-circular>
                              </v-layout>       
                          </v-img>
                        </v-card>
                        <v-btn small color="primary" dark @click.native="selectFile(2)"><v-icon>add_a_photo</v-icon></v-btn>
                        <input id="files" type="file" name="file2" ref="uploadInput" accept="image/*" :multiple="false" @change="detectFiles($event)" style="width:10px">
                        <v-text-field v-model="editedItem.serial2" label="Serial2"></v-text-field>
                    </v-flex>
                    </v-layout>
                </v-flex>      
                <v-flex xs12>
                  <v-text-field v-model="editedItem.memo" label="Memo"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-menu ref="datePicker" v-model="datePicker" :close-on-content-click="false" :nudge-right="40"
                   lazy transition="scale-transition" offset-y full-width  max-width="290px" min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field prepend-icon="event" v-model="editedItem.createdt" label="CreatedDate" 
                      @blur="date = parseDate(editedItem.createdt)"
                      persistent-hint  readonly v-on="on">
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="date" no-title @input="datePicker = false"></v-date-picker>
                  </v-menu>                
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <p v-if="editedIndex > -1"> 
             <v-btn round color="#e60000" dark @click="remove">Delete</v-btn>
            </p>
             <v-spacer></v-spacer>
             <v-btn round color="gray" dark  @click="close">Cancel</v-btn>
             <v-btn round color="primary" dark @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>  
    </transition>
  </div>
</template>

<script>
import firebase from '../firebase.js';
import imgRough from "@/assets/svg3/eRoughPhoto.svg";
import imgPlan from "@/assets/svg3/ePlanPhoto.svg";

export default {
    data: () => ({
      img: { blank: require('../assets/blank.png')},
      svgRouph: imgRough,
      svgPlan: imgPlan,
      dialog: false,
      search:'',
      date: new Date().toISOString().substr(0, 10),
      datePicker:false,
      pagination: {totalItems:0, rowsPerPage:12},
      selected: [],
      headers: [
        { text: 'Serial1', value: 'serial1',align:'left', width: "2%" },
        { text: 'Serial2', value: 'serial2',align:'left', width: "2%" },
        { text: 'Memo', value: 'memo',align:'left', width: "5%" },
        { text: 'Created', value: 'createdt',align:'left', width: "2%" },
        { text: 'Actions', value: '',align:'center', sortable: false, width: "1%" }
      ],
      imageName: '',
      loading:false,
      progressUpload: 0,
      uploadTask: null,
      uploading1:false,
      uploading2:false,
      selectedImgNo:0,
      errorMessage:'',
      //catalogs: [],
      editedIndex: -1,
      editedItem: {
        key:'',
        serial1: '',
        serial2: '',
        file1:'',
        file2:'',
        url1:'',
        url2:'',
        memo: '',
        createdt: new Date().toISOString().substr(0, 10),
        valid:0,
      },
    }),
  
    created () {
      if (!this.$store.state.isLogin){
        this.$router.push({ name: 'login' });
      }
      this.initialize(true);
    },
    updated(){
      //this.needRefreshitems = true;
    },
    computed: {
      isThereData(){
        if(this.catalogs.length>0){
          return true;
        } else {
          return false;
        }
      },
      catalogs(){
        return this.$store.state.catalogs;
      },
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },
      pages () {
        if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null) {
          return 0
        }
        //return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
        return Math.ceil(this.catalogs.length/this.pagination.rowsPerPage);
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },

      date () { //date(val)
        this.editedItem.createdt = this.formatDate(this.date)
      },

      uploadTask: function () {
        this.uploadTask.on('state_changed', sp => {
          this.progressUpload = Math.floor(sp.bytesTransferred / sp.totalBytes * 100)
        },
        null,
        () => {
          this.uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
            if(this.selectedImgNo==1){
              this.uploading1 = false;
              this.editedItem.url1 = downloadURL;
              this.$emit('editedItem.url1', downloadURL);
            } else {
              this.uploading2 = false;
              this.editedItem.url2 = downloadURL;
              this.$emit('editedItem.url2', downloadURL);
            }
          });
        });
      },
    },

    methods: {
      formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${year}/${month}/${day}`
      },
      parseDate (date) {
        if (!date) return null
        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
      initialize (force) {
        this.loading = true;
        if(this.$store.state.catalogs.length < 1 || force===true){
          this.catalogs = [];
          this.$store.dispatch('getCatalogAll');
        }
        this.loading = false;
      },
      selectFile (no) {
        if(no == 1){this.uploading1 = false;}
        if(no == 2){this.uploading2 = false;}
        this.selectedImgNo = no;
        this.$refs.uploadInput.click();
      },
      detectFiles (e) {
        let fileList = e.target.files || e.dataTransfer.files
        Array.from(Array(fileList.length).keys()).map(x => {
          this.upload(fileList[x]);
        })
      },
     upload (file) {
        if(this.selectedImgNo === 1){
            this.editedItem.file1 = file.name;
            this.uploading1 = true;
          }
        if(this.selectedImgNo === 2){
           this.editedItem.file2 = file.name;
           this.uploading2 = true;
         }
        this.uploadTask= firebase.myStorage().ref('catalogs/' + file.name).put(file);
      },
      addItem(){
          this.editedIndex = -1;
          this.editedItem = {
                key: '',
                serial1: '',
                serial2: '',
                file1: "blank.png",
                file2: "blank.png",
                url1: this.img.blank,
                url2: this.img.blank,
                memo: '',
                createdt: new Date().toISOString().substr(0, 10),
                valid: 0
          };
          this.dialog = true;   // dialog close 
      },
    
      editItem (item) {
          //alert(item.serial1 + ' ' + item.serial2);
        this.editedIndex = this.catalogs.indexOf(item);
        this.editedItem = Object.assign({}, item);
        if(!this.editedItem.file1){
          this.editedItem.file1 = "blank.png";
          this.editedItem.url1 = this.img.blank;
        }
        if(!this.editedItem.file2){
          this.editedItem.file2 = "blank.png";
            this.editedItem.url2 = this.img.blank;
        }
        this.dialog = true;
      },    

      close () {
        this.dialog = false;
        //this.initialize(true);
        this.$forceUpdate();
      },

      remove(){
        var res = confirm("Are you sure you want to delete this item?");
        if(res == true){
          this.$store.dispatch('deleteCatalog', this.editedItem);
          this.initialize(true);
        } 
        this.close();
      },

      save () {
        if (this.editedIndex === -1) {
          this.$store.dispatch('addCatalog', this.editedItem);
        } else {
          this.$store.dispatch('updateCatalog', this.editedItem);
        }
        this.initialize(true);
        this.close();
      }
    }
  }
</script>

<style>
table.v-table tbody td:first-child, 
table.v-table tbody td:not(:first-child), 
table.v-table tbody th:first-child, 
table.v-table tbody th:not(:first-child), 
table.v-table thead td:first-child, 
table.v-table thead td:not(:first-child), 
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child) {
  padding: 0 15px  !important;
  /*font-size:20px  !important;*/
}
table.v-table thead th{
    font-size:20px  !important;
}
input[type="file"] {
  position: absolute;
  clip: rect(0,0,0,0);
}

</style>